import { createContext, useContext } from 'react';
export const FeaturesContext = createContext({
    useFeatures() {
        return { loading: false, data: {} };
    },
    useFeature(name, fallback) {
        return fallback;
    },
});
export function useFeatures() {
    return useContext(FeaturesContext).useFeatures();
}
export function useFeature(name, fallback) {
    return useContext(FeaturesContext).useFeature(name, fallback);
}
//# sourceMappingURL=features.js.map